import { useState, useEffect } from 'react';
import { getSystemFeatures, loadSystemFeatures } from '../utils/systemFeatures';

/**
 * The per-tenant feature toggles and the tax rate, for components that render
 * them. Starts from the last known values so nothing flickers, then refreshes
 * from the backend on mount.
 */
export function useSystemFeatures() {
    const [features, setFeatures] = useState(getSystemFeatures());

    useEffect(() => {
        let active = true;
        loadSystemFeatures().then(loaded => {
            if (active) setFeatures(loaded);
        });
        return () => { active = false; };
    }, []);

    return features;
}
